const NetworkDetectionsClientIp = (props) => {
  const clientIp = props?.row?.original?.log?.clientIp || "-";

  return <span>{clientIp}</span>;
};

export default NetworkDetectionsClientIp;
